import type { FC, ReactNode } from 'react'
import type { Material } from '@/types'

import { cms } from '@/lib/cms'
import Container from '@/components/generals/container'
import AppImage from '@/components/generals/app-image'
import SectionHeading from '@/components/generals/section-heading'

interface MaterialsSectionProps {
    materiales: Array<Material>
}

const MaterialsSection: FC<MaterialsSectionProps> = ({ materiales }): ReactNode => {
    if (materiales.length === 0) return null

    return (
        <section id='materiales' aria-labelledby='materiales-titulo' className='surface-grain relative bg-graphite py-24 md:py-32'>
            <Container>
                <SectionHeading
                    id='materiales-titulo'
                    align='center'
                    eyebrow='Materiales'
                    title='Materiales que transmiten distinción.'
                    description='Seleccionamos cada material por su carácter, su respuesta al grabado y la forma en que refleja la luz.'
                />

                <ul className='mt-16 flex flex-wrap justify-center gap-5'>
                    {materiales.map(material => (
                        <li
                            key={material.id}
                            className='reveal flex w-[calc(50%_-_0.625rem)] flex-col gap-4 sm:w-[calc(33.333%_-_0.84rem)] lg:w-[calc(20%_-_1rem)]'
                        >
                            <div className='relative aspect-square overflow-hidden rounded-sm border border-ivory/10 bg-black'>
                                <AppImage
                                    src={material.imagen}
                                    alt={material.imagen_alt}
                                    sizes='(min-width: 1024px) 18vw, (min-width: 640px) 30vw, 45vw'
                                />
                            </div>

                            <div className='flex flex-col gap-2'>
                                <h3 className='font-heading text-2xl leading-tight font-medium text-foreground' data-mdlfy-cms={cms('materiales', material.id, 'nombre')}>
                                    {material.nombre}
                                </h3>

                                {material.descripcion && (
                                    <p className='text-sm leading-relaxed text-muted-foreground' data-mdlfy-cms={cms('materiales', material.id, 'descripcion')}>
                                        {material.descripcion}
                                    </p>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>

                <p className='mx-auto mt-14 max-w-2xl text-center text-xs leading-relaxed text-ivory/55'>
                    Las características, los acabados y la disponibilidad de cada material dependen del producto y se confirman en la propuesta de cotización.
                </p>
            </Container>
        </section>
    )
}

export default MaterialsSection
